import React from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import HeroVideo from '../HeroVideo';
import BookSection from '../BookSection';
import BadgesSection from '../BadgesSection';
import { useLanguage } from '../../contexts/LanguageContext';

const Libro6Page: React.FC = () => {
    const { language } = useLanguage();
    const t = (es: string, en: string) => language === 'es' ? es : en;

    const handleThemeChange = (theme: number) => {
        // Navegar a la página del libro correspondiente
        const bookRoutes = {
            2: '/libros/1',
            3: '/libros/2', 
            4: '/libros/3',
            5: '/libros/4',
            6: '/libros/5',
            7: '/libros/6',
            8: '/libros/7',
            9: '/libros/8'
        };
        const route = bookRoutes[theme as keyof typeof bookRoutes];
        if (route) {
            window.location.href = route;
        }
    };

    return (
        <div className="min-h-screen bg-white">
            {/* Navbar */}
            <Navbar currentTheme={7} onThemeChange={handleThemeChange} />
            {/* Contenido principal con padding-top para el navbar fijo */}
            <main className="pt-14 sm:pt-16">
                {/* HeroVideo */}
                <HeroVideo theme={7} />
                {/* BookSection */}
                <BookSection theme={7} />
                {/* BadgesSection */}
                <BadgesSection theme={7} />
            </main>
            {/* Footer */}
            <Footer />
        </div>
    );
};

export default Libro6Page; 